import { motion } from "framer-motion";

const PARTNERS = [
  { key: "sakani", name: "سكني", src: "/images/partners/sakani.png", className: "max-h-16 lg:max-h-20" },
  { key: "aqarmap", name: "عقارماب", src: "/images/partners/aqarmap.png", className: "max-h-16 lg:max-h-20" },
  { key: "bayut", name: "Bayut", src: "/images/partners/bayut.png", className: "max-h-12 lg:max-h-16" },
  { key: "ministry", name: "وزارة الشؤون البلدية والقروية والإسكان", src: "/images/partners/ministry.png", className: "max-h-20 lg:max-h-24" },
  { key: "rega", name: "الهيئة العامة للعقار", src: "/images/partners/rega.png", className: "max-h-16 lg:max-h-20" },
  { key: "secure-shield", name: "Secure Shield Solutions", src: "/images/partners/secure-shield-solutions.png", className: "max-h-20 lg:max-h-24" },
  { key: "elite-touch", name: "Elite Touch Design", src: "/images/partners/elite-touch-design.png", className: "max-h-20 lg:max-h-24" },
  { key: "atlal-alkhaleejia", name: "أطلال الخليجية", src: "/images/partners/atlal-alkhaleejia.png", className: "max-h-20 lg:max-h-24" },
];

export default function Partners() {
  return (
    <section
      id="partners"
      data-testid="section-partners"
      className="relative py-20 lg:py-28 bg-brand-cream overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mx-auto mb-10 text-center"
        >
          <span
            className="block text-xs text-brand-accent mb-5"
            data-testid="partners-kicker"
          >
            شركاء النجاح
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl text-brand-ink mb-5 leading-tight"
            data-testid="partners-headline"
          >
            علامات موثوقة تشاركنا الجودة
          </h2>
          <p className="text-base text-brand-mute leading-loose max-w-2xl mx-auto">
            نعمل جنبًا إلى جنب مع نخبة من الجهات الرسمية والمنصات المعتمدة لضمان أعلى معايير الجودة،
            الالتزام، والاستدامة في كل تفصيلة من تفاصيل مشاريعنا.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-4"
          data-testid="partners-grid"
        >
          {PARTNERS.map((p) => (
            <div
              key={p.key}
              className="h-32 lg:h-36 bg-white border border-brand-border flex items-center justify-center px-5 rounded-2xl shadow-sm group hover:border-brand-accent hover:shadow-lg transition-all duration-500 hover:-translate-y-0.5"
              data-testid={`partner-${p.key}`}
            >
              <img
                src={p.src}
                alt={p.name}
                className={`w-full object-contain rounded-xl transition-all duration-500 opacity-90 group-hover:opacity-100 ${p.className}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

